/* TDT · Vídeo */
if (!customElements.get('tdt-video')) {
  class TdtVideo extends HTMLElement {
    connectedCallback() {
      this.playBtn = this.querySelector('[data-play]');
      this.template = this.querySelector('template[data-player]');
      this.bgVideo = this.querySelector('.tdt-vd__bg-video');
      this.modal = this.querySelector('.tdt-vd__modal');
      this.inline = this.querySelector('.tdt-vd__inline');
      this.slot = this.querySelector('[data-slot]');

      this.playBtn?.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));

      if (this.modal) {
        // Cerrar al pulsar fuera del vídeo o con Esc (evento nativo "cancel")
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) this.close();
        });
        this.modal.addEventListener('close', () => this.cleanup());
      }

      this.onKey = (e) => {
        if (e.key === 'Escape' && this.inline && !this.inline.hidden) this.close();
      };
      document.addEventListener('keydown', this.onKey);

      this.initBgVisibility();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      this.observer?.disconnect();
      this.cleanup();
    }

    open() {
      if (!this.template || !this.slot) return;
      this.slot.replaceChildren(this.template.content.cloneNode(true));
      this.bgVideo?.pause();

      if (this.modal) {
        this.modal.showModal();
        document.documentElement.classList.add('tdt-vd-lock');
        this.modal.querySelector('[data-close]')?.focus();
      } else if (this.inline) {
        this.inline.hidden = false;
        this.inline.querySelector('[data-close]')?.focus();
      }

      // Vídeos nativos: forzar reproducción con sonido (lo permite el clic del usuario)
      const v = this.slot.querySelector('video');
      if (v) {
        v.muted = false;
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      }
    }

    close() {
      if (this.modal && this.modal.open) {
        this.modal.close(); // dispara "close" -> cleanup
      } else {
        this.cleanup();
      }
    }

    cleanup() {
      // Vaciar el reproductor detiene YouTube/Vimeo/vídeo y libera memoria
      if (this.slot) this.slot.replaceChildren();
      if (this.inline) this.inline.hidden = true;
      document.documentElement.classList.remove('tdt-vd-lock');
      if (this.inView !== false) this.playBg();
      if (this.playBtn && this.isConnected) this.playBtn.focus({ preventScroll: true });
    }

    playBg() {
      if (!this.bgVideo) return;
      this.bgVideo.muted = true;
      const p = this.bgVideo.play();
      if (p && p.catch) p.catch(() => {});
    }

    /* Pausar el vídeo de fondo cuando no se ve */
    initBgVisibility() {
      if (!this.bgVideo || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        const playing = this.slot && this.slot.childElementCount > 0;
        if (entry.isIntersecting && !playing) this.playBg();
        else this.bgVideo.pause();
      }, { threshold: 0.1 });
      this.observer.observe(this);
    }
  }

  customElements.define('tdt-video', TdtVideo);
}
